export interface Listener<T> {
  (event: T): void;
}

export interface Disposable {
  dispose();
}

// https://typescript-jp.gitbook.io/deep-dive/main-1/typed-event
export class TypedEvent<T> {
  private listeners: Listener<T>[] = [];
  private listenersOncer: Listener<T>[] = [];

  on(listener: Listener<T>): Disposable {
    this.listeners.push(listener);
    return {
      dispose: () => this.off(listener)
    };
  }

  one(listener: Listener<T>) {
    this.listenersOncer.push(listener);
    return {
      dispose: () => this.off(listener)
    };
  }

  off(listener: Listener<T>) {
    // eslint-disable-next-line no-restricted-syntax
    for (const listeners of [this.listeners, this.listenersOncer]) {
      const callbackIndex = listeners.indexOf(listener);
      if (callbackIndex > -1) listeners.splice(callbackIndex, 1);
    }
  }

  trigger(event: T) {
    /** Update any general listeners */
    this.listeners.forEach((listener) => listener(event));

    /** Clear the `once` queue */
    this.listenersOncer.forEach((listener) => listener(event));
    this.listenersOncer = [];
  }
}
